import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "bi bi-arrow-up" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "bi bi-arrow-down" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasControls)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["seq-dashboard-movable__actions", _ctx.variantClass]
      }, [
        _createVNode("button", {
          type: "button",
          class: "seq-dashboard-movable__btn",
          disabled: !_ctx.canMoveUp,
          "aria-label": "Move section up",
          title: "Move up",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveUp && _ctx.moveUp(...args)))
        }, [
          _hoisted_1
        ], 8, ["disabled"]),
        _createVNode("button", {
          type: "button",
          class: "seq-dashboard-movable__btn",
          disabled: !_ctx.canMoveDown,
          "aria-label": "Move section down",
          title: "Move down",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveDown && _ctx.moveDown(...args)))
        }, [
          _hoisted_2
        ], 8, ["disabled"])
      ], 2))
    : _createCommentVNode("", true)
}